import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import type { StripeCustomer } from 'types/payments'

import { QUERIES } from '@/enums/queries'

import { getStripeCustomer } from './services/loadStripeCustomer'

export const useLoadStripeCustomer = (
  options?: Omit<
    UseQueryOptions<
      StripeCustomer | null,
      Error,
      StripeCustomer | null,
      [string]
    >,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<StripeCustomer | null, Error> => {
  return useQuery({
    queryKey: [QUERIES.PAYMENTS.GET_STRIPE_CUSTOMER],
    queryFn: async () => await getStripeCustomer(),
    ...options,
  })
}

export const invalidateLoadStripeCustomer = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PAYMENTS.GET_STRIPE_CUSTOMER],
    exact: false,
  })
}
